import FAQ from '@/components/global/FAQ';
import LogoIcon from '@/components/global/LogoIcon';

import { GROQImage, IFAQ } from '@/sanity/lib/definitions';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { PortableText } from 'next-sanity';
import Link from 'next/link';
import { PortableTextBlock } from 'sanity';

export default function FAQSection({
  title,
  faqs,
}: {
  title: PortableTextBlock[];
  faqs: { questions: IFAQ }[];
}) {
  return (
    <section id="faq-section" className="lg:pt-[8.5rem] lg:pb-[12rem] pt-[10rem] pb-[7rem] bg-[#121B30]">
      <div className="container flex flex-col gap-[6rem] lg:gap-[9rem]">
        <div className="text-offwhite flex items-center justify-between">
          <div className="prose-headings:text-[6rem] lg:prose-headings:text-[9rem]">
            {title && (
              <PortableText value={title} components={richTextComponent} />
            )}
          </div>
          <LogoIcon fill="#dadada" className="lg:w-[7.25rem] w-[5rem]" />
        </div>

        <div className="flex flex-col gap-[5rem]">
          <FAQ faqs={faqs} />

          <div className="hidden lg:flex items-center justify-between text-offwhite uppercase w-full border-t border-[#F2F0EF14] pt-[8rem]">
            <span className="text-[6rem] italic font-newsreader font-[300]">Still have questions?</span>
            <Link className="text-[4rem] font-nunito font-[200]" href="mailto:info@veylor.com">
              Contact us at info@veylor.com
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
